import Immutable from "seamless-immutable";
import {
  CHECK_RENEWABILITY,
  CHECK_RENEWABILITY_SUCCESS,
  CHECK_RENEWABILITY_FAILURE,
  RENEWAL_PAY_NOW,
  RENEWAL_PAY_NOW_SUCCESS,
  RENEWAL_PAY_NOW_FAILURE,
  GET_STATUS_MESSAGE,
  GET_STATUS_MESSAGE_SUCCESS,
  GET_STATUS_MESSAGE_FAILURE,
  RENEWAL_TIQ_HOME,
  RENEWAL_TIQ_HOME_SUCCESS,
  RENEWAL_TIQ_HOME_FAILURE
} from "../actions/onlineRenewal";

const INITIAL_STATE = Immutable({
  checkRenewal: null,
  renewalPayNow: null,
  getStatusMsg:null,
  renewalTiqHome:null,
});

function onlineRenewalReq(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CHECK_RENEWABILITY:
      return state
        .setIn(["checkRenewal", "loading"], true)
        .setIn(["checkRenewal", "status"], false);
    case CHECK_RENEWABILITY_SUCCESS:
      return state
        .setIn(["checkRenewal", "loading"], false)
        .setIn(["checkRenewal", "items"], action.data)
        .setIn(["checkRenewal", "status"], true);
    case CHECK_RENEWABILITY_FAILURE:
      return state
        .setIn(["checkRenewal", "loading"], false)
        .setIn(["checkRenewal", "status"], false);
    case RENEWAL_PAY_NOW:
      return state
        .setIn(["renewalPayNow", "loading"], true)
        .setIn(["renewalPayNow", "status"], false);
    case RENEWAL_PAY_NOW_SUCCESS:
      return state
        .setIn(["renewalPayNow", "loading"], false)
        .setIn(["renewalPayNow", "items"], action.data)
        .setIn(["renewalPayNow", "status"], true);
    case RENEWAL_PAY_NOW_FAILURE:
      return state
        .setIn(["renewalPayNow", "loading"], false)
        .setIn(["renewalPayNow", "status"], false);
    case GET_STATUS_MESSAGE:
      return state
        .setIn(["getStatusMsg", "loading"], true)
        .setIn(["getStatusMsg", "status"], false);
    case GET_STATUS_MESSAGE_SUCCESS:
      return state
        .setIn(["getStatusMsg", "loading"], false)
        .setIn(["getStatusMsg", "items"], action.data)
        .setIn(["getStatusMsg", "status"], true);
    case GET_STATUS_MESSAGE_FAILURE:
      return state
        .setIn(["getStatusMsg", "loading"], false)
        .setIn(["getStatusMsg", "status"], false);
        case RENEWAL_TIQ_HOME:
      return state
        .setIn(["renewalTiqHome", "loading"], true)
        .setIn(["renewalTiqHome", "status"], false);
    case RENEWAL_TIQ_HOME_SUCCESS:
      return state
        .setIn(["renewalTiqHome", "loading"], false)
        .setIn(["renewalTiqHome", "items"], action.data)
        .setIn(["renewalTiqHome", "status"], true);
    case RENEWAL_TIQ_HOME_FAILURE:
      return state
        .setIn(["renewalTiqHome", "loading"], false)
        .setIn(["renewalTiqHome", "status"], false);
    default:
      return state;
  }
}

export default onlineRenewalReq;
